// External booking system (Timely). All "Book Now" actions send clients here.
export const TIMELY_BOOKING_URL = "https://bookings.gettimely.com/slaviclashesbrows/bb/book";
// Client account / login lives inside Timely too.
export const TIMELY_ACCOUNT_URL = "https://bookings.gettimely.com/slaviclashesbrows/bb/account";

export const goToTimely = () => {
  window.open(TIMELY_BOOKING_URL, "_blank", "noopener,noreferrer");
};

export const goToTimelyAccount = () => {
  window.open(TIMELY_ACCOUNT_URL, "_blank", "noopener,noreferrer");
};

